import React, { useState, useEffect } from "react";
import {
    Box,
    Typography,
    Button,
    Divider,
    Paper,
    useMediaQuery,
    RadioGroup,
    FormControlLabel,
    FormControl,
    Radio,
    FormLabel,
    TextField,
    CircularProgress,
} from "@mui/material";
import Cookies from "js-cookie";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";


export default function PetLostMember() {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const isMobile = useMediaQuery("(max-width:900px)");

    const getUserId = () => {
        const id = Cookies.get("id");
        return id;
    };

    useEffect(() => {
        if(getUserId()) {
            navigate("/pet_lost_report?member=true&Logged=true"); 
        }
        window.scrollTo(0, 0);
    }, []);

    const button1Style = {
        backgroundColor: "#FFB60C",
        width: "100%", marginTop: 10,
        color: "#000",
        cursor: "pointer",
        fontSize: isMobile ? "15px" : "16px",
        fontWeight: 700,
        padding: isMobile ? "8px 16px" : "10px 20px",
        mt: 2,
        borderRadius: 5,
    };

    const button2Style = {
        backgroundColor: "#FFFFFF",
        width: "100%", marginTop: 10,
        color: "#000",
        cursor: "pointer",
        fontSize: isMobile ? "15px" : "16px",
        fontWeight: 700,
        padding: isMobile ? "8px 16px" : "10px 20px",
        mt: 2,
        borderRadius: 5,
        border: "1px solid #717182",

    };

    const BoxStyle = {
        width: isMobile ? 340 : 428,
        height: isMobile ? 300 : 382,
        backgroundColor: "#FFFFFF",
        padding: 2,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 1,
        borderRadius: 5,
    };


    return (
        <Box
            sx={{ background: "#FCF8F3", minHeight: "100vh", pt: 15, position: "relative" }}
        >
            <Navbar />
            <Box sx={{ color: "black", minWidth: 0, position: "absolute", left: isMobile ? 10 : 80, display: 'flex', }}>
                <Button
                    sx={{ color: "black", minWidth: 0, }}
                    onClick={() => navigate("/pet_lost_search")}
                >
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="20" viewBox="0 0 14 24" fill="none">
                        <path d="M12 22L2 12L12 2" stroke="#050505" stroke-width="3.33333" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </Button>
                <Typography sx={{ ml: 1, fontSize: isMobile ? 26 : 34, fontWeight: 700 }}>{t('Publish')}</Typography>
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 5, pt: 10, }}>
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 5 }}>
                    <Box sx={{ display: 'flex', flexDirection: isMobile ? 'column' : 'row', alignItems: 'center', gap: 5 }}>
                        <Box sx={BoxStyle}>
                            <Box sx={{ display: 'flex', flexDirection: isMobile ? 'row' : 'column', alignItems: 'center', gap: 1 }}>
                                <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M0 32C0 14.3269 14.3269 0 32 0C49.6731 0 64 14.3269 64 32C64 49.6731 49.6731 64 32 64C14.3269 64 0 49.6731 0 32Z" fill="#FFF2D3" />
                                    <path d="M37.3359 30.6667L40.0026 33.3333L45.3359 28" stroke="#FFB60C" stroke-width="2.66667" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M37.3307 44V41.3333C37.3307 39.9188 36.7688 38.5623 35.7686 37.5621C34.7684 36.5619 33.4119 36 31.9974 36H23.9974C22.5829 36 21.2264 36.5619 20.2262 37.5621C19.226 38.5623 18.6641 39.9188 18.6641 41.3333V44" stroke="#FFB60C" stroke-width="2.66667" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M27.9974 30.6667C30.9429 30.6667 33.3307 28.2789 33.3307 25.3333C33.3307 22.3878 30.9429 20 27.9974 20C25.0519 20 22.6641 22.3878 22.6641 25.3333C22.6641 28.2789 25.0519 30.6667 27.9974 30.6667Z" stroke="#FFB60C" stroke-width="2.66667" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                                <Typography sx={{ fontSize: isMobile ? 20 : 26, fontWeight: 700 }}>{t("PTagMember")}</Typography>
                            </Box>
                            <Typography sx={{ fontSize: 13, color: '#717182', mb: 1 }}>{t("enjoymore")}</Typography>
                            <Typography sx={{ fontSize: 13, color: '#717182', alignSelf: 'flex-start' }}>{t("enjoy1")}</Typography>
                            <Typography sx={{ fontSize: 13, color: '#717182', alignSelf: 'flex-start' }}>{t("enjoy2")}</Typography>
                            <Typography sx={{ fontSize: 13, color: '#717182', alignSelf: 'flex-start' }}>{t("enjoy3")}</Typography>
                            <Typography sx={{ fontSize: 13, color: '#717182', alignSelf: 'flex-start' }}>{t("enjoy4")}</Typography>
                            <button style={button1Style}
                                onMouseOver={(e) => {
                                    e.currentTarget.style.backgroundColor = "#ffcf60ff";
                                }}
                                onMouseOut={(e) => {
                                    e.currentTarget.style.backgroundColor = "#FFB60C";
                                }}
                                onClick={() => {
                                    if (getUserId()) {
                                        navigate("/pet_lost_report?member=true");
                                    }
                                    else {
                                        navigate("/login?petlostreport=true");
                                    }
                                }}>
                                {t("loginContinue")}
                            </button>
                        </Box>
                        <Box sx={BoxStyle}>
                            <Box sx={{ display: 'flex', flexDirection: isMobile ? 'row' : 'column', alignItems: 'center', gap: 1 }}>
                                <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M0 32C0 14.3269 14.3269 0 32 0C49.6731 0 64 14.3269 64 32C64 49.6731 49.6731 64 32 64C14.3269 64 0 49.6731 0 32Z" fill="#F3F4F6" />
                                    <path d="M37.3307 44V41.3333C37.3307 39.9188 36.7688 38.5623 35.7686 37.5621C34.7684 36.5619 33.4119 36 31.9974 36H23.9974C22.5829 36 21.2264 36.5619 20.2262 37.5621C19.226 38.5623 18.6641 39.9188 18.6641 41.3333V44" stroke="#4A5565" stroke-width="2.66667" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M27.9974 30.6667C30.9429 30.6667 33.3307 28.2789 33.3307 25.3333C33.3307 22.3878 30.9429 20 27.9974 20C25.0519 20 22.6641 22.3878 22.6641 25.3333C22.6641 28.2789 25.0519 30.6667 27.9974 30.6667Z" stroke="#4A5565" stroke-width="2.66667" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M38.6641 26.6641L45.3307 33.3307" stroke="#4A5565" stroke-width="2.66667" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M45.3307 26.6641L38.6641 33.3307" stroke="#4A5565" stroke-width="2.66667" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                                <Typography sx={{ fontSize: isMobile ? 20 : 26, fontWeight: 700 }}>{t("NotPTagMember")}</Typography>
                            </Box>
                            <Typography sx={{ fontSize: 13, color: '#717182', mb: 1 }}>{t("postInfo")}</Typography>
                            <Typography sx={{ fontSize: 13, color: '#717182', alignSelf: 'flex-start', }}>{t("basic1")}</Typography>
                            <Typography sx={{ fontSize: 13, color: '#717182', alignSelf: 'flex-start' }}>{t("basic2")}</Typography>
                            <Typography sx={{ fontSize: 13, color: '#717182', alignSelf: 'flex-start' }}>{t("basic3")}</Typography>
                            <Typography sx={{ fontSize: 13, color: '#717182', alignSelf: 'flex-start' }}>{t("basic4")}</Typography>
                            <button style={button2Style}
                                onMouseOver={(e) => {
                                    e.currentTarget.style.backgroundColor = "#a8a8a8ff";
                                }}
                                onMouseOut={(e) => {
                                    e.currentTarget.style.backgroundColor = "#ffffff";
                                }}
                                onClick={() => navigate("/pet_lost_report")}>
                                {t("guestContinue")}
                            </button>
                        </Box>
                    </Box>
                    <Typography sx={{ fontSize: 15, fontWeight: 400 }}>{t("NotAMemberYet")} <a style={{ textDecoration: 'underline', color: 'blue' }} href="/login">{t("SignUp")}</a></Typography>
                </Box>
                
            </Box>

            <Footer />
        </Box>
    );
}
